export function getBranchValue(): string | null {
  return sessionStorage.getItem('branchValue');
}
